"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EntityLevel;
(function (EntityLevel) {
    EntityLevel["Client"] = "Client";
    EntityLevel["Company"] = "Company";
    EntityLevel["Location"] = "Location";
    EntityLevel["Division"] = "Division";
    EntityLevel["Account"] = "Account";
    EntityLevel["Carrier"] = "Carrier";
})(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));
//# sourceMappingURL=EntityLevel.js.map